import { useDashboard } from "context/dashboard";

export const useOrganizationFeatures = () => {
  const { organization } = useDashboard();
  
  const hasFeature = (featureKey) => {
    if (!organization) return false;
    
    const features = {
      PERMIT_SUBLETTING_DISABLED: ['559024-8331']
    };
    
    return features[featureKey]?.includes(organization.organizationNumber) || false;
  };

  return { hasFeature };
};
